import React from "react";
import classes from "./Services.module.css";

const Services = (props) => {
  return <div className={classes.Services}>{props.children}</div>;
};

export default Services;
